import React from "react";

export default function AALogo() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <rect
          x="3"
          y="2"
          width="64"
          height="64"
          rx="4"
          fill="white"
          fillOpacity="0.01"
        />
      </g>
      <mask
        id="mask0"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="2"
        width="64"
        height="64"
      >
        <rect x="3" y="2" width="64" height="64" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <rect x="3" y="2" width="64" height="64" fill="#FFCC00" />
      </g>
      <path
        d="M29.6237 29.9282V36.8391H26.4225L29.6237 29.9282ZM48.0121 29.9282V36.8391H44.8109L48.0121 29.9282ZM46.337 21L34.6117 46.5144V21H27.9115L16 47H21.7696L24.0402 42.069H29.6237V47H40.1579L42.4286 42.069H48.0121V47H53V21H46.337Z"
        fill="black"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
